import { render, staticRenderFns } from "./download1Vue.vue?vue&type=template&id=57186edb"
import script from "./download1Vue.vue?vue&type=script&lang=js"
export * from "./download1Vue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports